var exports = {
  "Tp": "xfb577c5e--53d509--background",
  "iE": "xfb577c5e--53d509--wrapper",
  "DD": "xfb577c5e--53d509--title",
  "VO": "xfb577c5e--53d509--full-width",
};

module.exports = exports;
